// extracted by mini-css-extract-plugin
module.exports = {"countdown":"countdown_countdown__RStOx","countdownClockBox":"countdown_countdownClockBox__fav_y"};